export default __webpack_public_path__ + "img/carousel-background-yellow-669c9bcd.png";